import { useLang } from "../../i18n";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="relative overflow-hidden border-y border-[#9B7AE8]/15 bg-white py-6" data-testid="marquee-section">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg font-bold uppercase tracking-wide text-[#221A3D]/75 sm:text-xl">
              {item}
            </span>
            <span className="text-stroke-violet font-display text-lg font-extrabold opacity-60 sm:text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
